app.ui.registerUi('textarea-restricted', function (app) {
    //Email

    return {
        implementationExists: function () {
            return true; // implementation is entirely encapsulated within this file.
        },
        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },
        init: function ($scope) {

            //Usage with form parts
            //all object keys will be prefixed with .fp- for use with formParts.

            var settingsMap = {
                //Inputs
                'project-name':{
                    "maxlength": 100,
                    "maxlength-allow-negative": true,
                    "maxlength-force": false,
                    "mode": "input[type='text']"
                },
                'project-description': {
                    "maxlength": 100,
                    "maxlength-allow-negative": true,
                    "maxlength-force": false,
                    "mode":"input[type='text']"
                },
                //Textareas
                'what-it-does':{
                    "maxlength": 200,
                    "maxlength-allow-negative": true,
                    "maxlength-force": false
                },
                'your-inspiration':{
                    "maxlength": 200,
                    "maxlength-allow-negative": true,
                    "maxlength-force": false
                },
                'how-it-works':{
                    "maxlength": 200,
                    "maxlength-allow-negative": true,
                    "maxlength-force": false
                },
                'design-process':{
                    "maxlength": 200,
                    "maxlength-allow-negative": true,
                    "maxlength-force": false
                },
                'how-is-it-different':{
                    "maxlength": 200,
                    "maxlength-allow-negative": true,
                    "maxlength-force": false
                },
                'future-plans':{
                    "maxlength": 200,
                    "maxlength-allow-negative": true,
                    "maxlength-force": false
                },
                'awards': {
                    "maxlength": 200,
                    "maxlength-allow-negative": true,
                    "maxlength-force": false
                },
                'video': {
                    "maxlength": 100,
                    "maxlength-allow-negative": true,
                    "maxlength-force": false,
                },
            }

            var formParts = Object.keys(settingsMap);
            formParts = formParts.map(function (item) {
                return ".fp-" + item;
            });

            formParts.forEach(function (fp) {
                var unprefixed = fp.replace(".fp-", "");
                ['.feedback-group-aux', '.feedback-group-main'].forEach(function(wrapSelector) {
                    $(fp + " " + wrapSelector + " [data-component='textarea-restricted']").restrictedText(settingsMap[unprefixed]);
                });
            });

            //Usage with drag drop drop inputs

            $(".image-caption-card-col").each(function (i) {
                var id = i + 1;
                ['.feedback-group-aux', '.feedback-group-main'].forEach(function (wrapSelector) {
                    $(".image-caption-card-" + id + " " + wrapSelector + " [data-component='textarea-restricted']").restrictedText({
                        "maxlength-allow-negative": true,
                        "maxlength-force": false,
                    })
                });
            })

        }
    }

});

